import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["srcset"]
const _hoisted_2 = ["src", "srcset", "alt"]
const _hoisted_3 = ["innerHTML"]

import type { PropType } from "vue";
import type { BrandInfo } from "../auction/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'brand-info',
  props: {
    brandInfo: {
        type: Object as PropType<BrandInfo>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['brand-info-row'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['brand-info-logo'])
    }, [
      _createElementVNode("picture", null, [
        (
                        __props.brandInfo.logo.webp.srcset != null &&
                        __props.brandInfo.logo.webp.srcset != ''
                    )
          ? (_openBlock(), _createElementBlock("source", {
              key: 0,
              srcset: __props.brandInfo.logo.webp.srcset,
              type: "image/webp"
            }, null, 8 /* PROPS */, _hoisted_1))
          : _createCommentVNode("v-if", true),
        _createElementVNode("img", {
          src: __props.brandInfo.logo.img.src,
          srcset: __props.brandInfo.logo.img.srcset ?? undefined,
          alt: __props.brandInfo.logo.img.alt ?? undefined
        }, null, 8 /* PROPS */, _hoisted_2)
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['brand-info-text'])
    }, [
      _createElementVNode("div", {
        innerHTML: __props.brandInfo.description
      }, null, 8 /* PROPS */, _hoisted_3)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})